import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.put['Access-Control-Allow-Origin'] = '*';

const path = "/filiacoes";

class FiliacoesService {

  listarFiliacoes() {
    return axios.get(API + path)
  }

  pesquisarFiliacoes(filters) {
    const { nome, tipo, cpf } = filters;

    return axios.get(API + path + "/find", {
      params: {
        nome: nome ? nome : "",
        tipo: tipo ? tipo : "",
        cpf: cpf ? cpf : ""
      }
    });
  }

  validarFiliacoesCPF(cpf) {
    return axios.post(API + path + `/existe-relacionamento?cpf=${cpf ? cpf : null}`)
  }

  validar(values, idCrianca) {
    return axios.post(API + path + `/${idCrianca}/validar`, values)
  }

  editarFiliacao(id, filiacao, idCrianca) {
    return axios.put(API + path + `/${idCrianca}/atualizar/${id}`, filiacao);
  }

  getCertidaoObitoDownload(idFiliacao, idDocumento) {
    return axios.get(API + path + `/${idFiliacao}/anexo-certidao-obito/${idDocumento}`)
  }
}

const instanceFiliacoes = new FiliacoesService();
export default instanceFiliacoes;